export default __webpack_public_path__ + "static/media/submit.04a9f74b.jpg";